import { ReactNode, useState } from "react";
import type { MealType } from "../api/client";

/** Tints disponibles: els tipus de recepta + "dinner" (només franja, no recepta). */
type MealTint = MealType | "dinner";

interface Props {
  /** Nom de la recepta/ingredient — se'n treu la inicial si no hi ha foto. */
  name?: string;
  imageUrl?: string | null;
  /** Tint del gradient de fons. Per defecte, "lunch". */
  meal?: MealTint;
  /** Inicial explícita (sobreescriu la del nom). */
  initial?: string;
  /** Mida (px) de la inicial quan no hi ha foto. */
  size?: number;
  className?: string;
  children?: ReactNode;
}

/**
 * Tile amb tint segons el tipus d'àpat. Mostra la foto si existeix; si no
 * (o si falla la càrrega), cau de manera elegant al gradient + inicial.
 * La mida/forma (amplada, alçada, radi) la controla qui el fa servir via className.
 */
export function Thumb({ name, imageUrl, meal = "lunch", initial, size = 34, className = "", children }: Props) {
  const [imgOk, setImgOk] = useState(true);
  const init = (initial ?? name?.[0] ?? "·").toUpperCase();
  const showImg = Boolean(imageUrl) && imgOk;

  return (
    <div className={`thumb mt-${meal} ${className}`}>
      {!showImg && (
        <span className="init" style={{ fontSize: size }}>
          {init}
        </span>
      )}
      {imageUrl && imgOk && (
        <img src={imageUrl} alt={name ?? ""} loading="lazy" onError={() => setImgOk(false)} />
      )}
      {children}
    </div>
  );
}
